import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1daa9119"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FgElementWrapper" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "ErrorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-Not-Valid': _ctx.showEmailError }, "EmailInputWrapper"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        class: _normalizeClass(["EmailInput FgInput js-Input", { HasFocus: _ctx.hasFocus, HasValue: _ctx.email }]),
        "data-cy": "EmailInput",
        "aria-label": "Email",
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveEmail(true, $event))),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFocused(true))),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveEmail(false, $event))),
        value: _ctx.email,
        name: "Email",
        autocomplete: "email",
        type: "text",
        ref: "input",
        maxlength: "128"
      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_2),
      _createElementVNode("label", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setFocusOnInput && _ctx.setFocusOnInput(...args))),
        class: "FgLabel",
        for: "emailInput"
      }, "Email")
    ]),
    (_ctx.showEmailError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Please enter a valid email address "))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}